module.exports = __webpack_public_path__ + "img/status2.cee06dfb.svg";